var map = {
	"./0.jpg": "./src/assets/device_images/0.jpg",
	"./1.jpg": "./src/assets/device_images/1.jpg",
	"./10.jpg": "./src/assets/device_images/10.jpg",
	"./11.jpg": "./src/assets/device_images/11.jpg",
	"./12.jpg": "./src/assets/device_images/12.jpg",
	"./2.jpg": "./src/assets/device_images/2.jpg",
	"./3.jpg": "./src/assets/device_images/3.jpg",
	"./4.jpg": "./src/assets/device_images/4.jpg",
	"./5.jpg": "./src/assets/device_images/5.jpg",
	"./6.jpg": "./src/assets/device_images/6.jpg",
	"./7.jpg": "./src/assets/device_images/7.jpg",
	"./8.jpg": "./src/assets/device_images/8.jpg",
	"./9.jpg": "./src/assets/device_images/9.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/device_images sync recursive ^\\.\\/.*\\.jpg$";